import React from 'react';
import styles from './index.module.scss';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { severityRatingEnums } from 'containers/Pages/Events/Layouts';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { translateValue } from 'utils/methods/helpers';

const useStyles = makeStyles(theme => {
  return {
    standardText: {
      color: theme.palette.severity.notRated,
    },
    veryHighText: {
      color: theme.palette.severity.high,
    },
    highText: {
      color: theme.palette.severity.high,
    },
    mediumText: {
      color: theme.palette.severity.medium,
    },
    lowText: {
      color: theme.palette.severity.low,
    },
    veryLowText: {
      color: theme.palette.severity.low,
    },
    widgetScrollBar: {
      '&::-webkit-scrollbar': {
        width: '0.7em',
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '10px',
        backgroundColor: theme.palette.primary.main,
      },
      '& ::-webkit-scrollbar-corner': {
        backgroundColor: theme.palette.background.paper,
      },
    },
  };
});

const DailyTask = ({
  title,
  taskData,
  shouldTranslate = true,
  blankItemLabel = 'Tasks',
}) => {
  const classes = useStyles();
  let di = [
    { itemName: translateValue(blankItemLabel), count: 0, scheduledCount: 0 },
  ];
  if (taskData && !isEmpty(taskData)) {
    di = taskData;
  }
  const data = {
    title: title,
    dashboardItems: di,
  };
  const getColour = severityRating => {
    switch (severityRating) {
      case severityRatingEnums.veryHigh:
        return classes.veryHighText;
      case severityRatingEnums.high:
        return classes.veryHighText;
      case severityRatingEnums.medium:
        return classes.mediumText;
      case severityRatingEnums.low:
        return classes.lowText;
      case severityRatingEnums.veryLow:
        return classes.veryLowText;
      default:
        return classes.standardText;
    }
  };
  return (
    <Box className={cn(styles.widget, classes.widgetScrollBar)}>
      <Box className={styles.left}>
        <span className={styles.title}>{translateValue(data.title)}</span>
        {data.dashboardItems.map((item, index) => {
          return (
            <Box className={styles.tasks} key={index}>
              <span
                className={cn(styles.label, getColour(item.severityRating))}
              >
                {shouldTranslate
                  ? translateValue(item.itemName)
                  : item.itemName}
              </span>
              <span style={{ color: getColour(item.severityRating) }}>
                {item.count}/{item.scheduledCount}
              </span>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
DailyTask.propTypes = {
  title: PropTypes.string,
  taskData: PropTypes.array,
  shouldTranslate: PropTypes.bool,
  blankItemLabel: PropTypes.string,
};
export default DailyTask;
